import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {useSelector} from "react-redux";

const BackDrop = () => {

	const { isBackdropLoading } = useSelector(state => state.allLoaders);

    return (
        <div id={'segment-backdrop'}>
            <Backdrop
		        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
		        open={isBackdropLoading}
		        // onClick={handleClose}
	      	>
		        <CircularProgress color="inherit" />
	      	</Backdrop>
        </div>
    );
}

export default BackDrop;
